import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQuestionTypeIconFileSubmission = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		d: "M21 14.2503V20.2503C21 20.6645 20.6642 21.0003 20.25 21.0003H3.75C3.33579 21.0003 3 20.6645 3 20.2503V14.2503C3 13.6729 3.625 13.3121 4.125 13.6008C4.35705 13.7347 4.5 13.9823 4.5 14.2503V19.5003H19.5V14.2503C19.5 13.6729 20.125 13.3121 20.625 13.6008C20.857 13.7347 21 13.9823 21 14.2503ZM8.78062 8.03091L11.25 5.5606V14.2503C11.25 14.8276 11.875 15.1885 12.375 14.8998C12.6071 14.7658 12.75 14.5182 12.75 14.2503V5.5606L15.2194 8.03091C15.6279 8.43938 16.3253 8.2525 16.4748 7.69451C16.5442 7.43555 16.4702 7.15923 16.2806 6.96966L12.5306 3.21966C12.2377 2.92637 11.7623 2.92637 11.4694 3.21966L7.71938 6.96966C7.3109 7.37813 7.49779 8.07562 8.05578 8.22513C8.31474 8.29452 8.59105 8.22048 8.78062 8.03091Z",
		fill: "currentColor"
	}) })
});
export default SvgQuestionTypeIconFileSubmission;
